export default {"src":"https://fishbrain.com/_next/static/media/img_trans.4f4e80a6.gif","height":1,"width":1,"blurWidth":0,"blurHeight":0};